<div class="banner">
    <div class="col-12 pb-5">
        <h1>Thank You!</h1>
    </div>
</div>

<div>
    <iui-messages #messages  class="ms-auto me-auto"></iui-messages>
</div>

<div class="tabcontent">
    <div class="row">
        <div class="col-9" *ngIf="leaseApplicationData && !conditionalTextObject.monthlyInvoiceManualPay">
            <div *ngIf="!conditionalTextObject.renew">
                <div class="col-12 ps-0" *ngIf="!conditionalTextObject.payNow && !conditionalTextObject.monthlyBilling">
                    <p>
                        <span>You have started your short code order, and your short codes are currently in Pending New
                            status.</span>
                        <span>Your Order ID is: <a class="link" style="cursor: pointer;"
                                [routerLink]="['/dashboard',{ outlets: { 'navbar-tab': ['my-shortcodes', { outlets: { 'my-shortcode-tab': ['invoice', pendingOrder.orderId] } }] } }]">{{
                                pendingOrder.orderId }}</a>
                        </span>
                    </p>
                    <p>
                        <span>You will receive an email notification with a copy of your invoice shortly.</span>
                        <span>You can also download your invoice using the link, below.</span>
                        <span>You have 60 days to pay for this short code order.</span>
                    </p>

                    <a class="link lg" style="cursor: pointer;" (click)="downloadInvoicePdf()">Download Invoice</a>
                </div>
                <div class="col-12 ps-0" *ngIf="!conditionalTextObject.payNow && conditionalTextObject.monthlyBilling">
                    <p>
                        <span>You have started your short code order, and your short codes are currently in Pending New
                            status.</span>
                        <span>Your Order ID is: <a class="link" style="cursor: pointer;"
                                [routerLink]="['/dashboard',{ outlets: { 'navbar-tab': ['my-shortcodes', { outlets: { 'my-shortcode-tab': ['invoice', pendingOrder.orderId] } }] } }]">{{
                                pendingOrder.orderId }}</a>
                        </span>
                    </p>
                    <p>
                        <span>You will receive an email notification with a copy of your invoice shortly.</span>
                        <span>You can also download your invoice using the link, below. You have 60 days to pay for this
                            short code order.</span>
                    </p>
                    <a class="link lg" style="cursor: pointer;" (click)="downloadInvoicePdf()">Download Invoice</a>
                    <p class="mt-2">Since you have chosen to automatically renew the short code(s) on this order into
                        monthly billing upon
                        payment of the initial pre-paid term, if payment is received by check or wire transfer or paid
                        on-line with
                        a credit card; a billed monthly order will be created at that time. The short code(s) will be
                        billed
                        monthly
                        following the completion of the pre-paid term.</p>
                </div>
                <div class="col-12 ps-0" *ngIf="conditionalTextObject.payNow && !conditionalTextObject.monthlyBilling">
                    <p>
                        <span>You have completed your short code order, and your short code(s) are now in Approved
                            status.</span>
                        <span>Your Order ID is: <a class="link" style="cursor: pointer;"
                                [routerLink]="['/dashboard',{ outlets: { 'navbar-tab': ['my-shortcodes', { outlets: { 'my-shortcode-tab': ['receipt', pendingOrder.orderId] } }] } }]">{{
                                pendingOrder.orderId }}</a>
                        </span>
                    </p>
                    <p>
                        <span>You will receive an email notification with a copy of your receipt shortly. </span>
                        <span>You can also download your receipt using the link, below.</span>
                    </p>
                    <a class="link lg" style="cursor: pointer;" (click)="downloadReceiptPdf()">Download Receipt</a>
                </div>
                <div class="col-12 ps-0" *ngIf="conditionalTextObject.payNow && conditionalTextObject.monthlyBilling">
                    <p>
                        <span>You have completed your short code order, and your short code(s) are now in Approved
                            status.</span>
                        <span>Your Order ID is: <a class="link" style="cursor: pointer;"
                                [routerLink]="['/dashboard',{ outlets: { 'navbar-tab': ['my-shortcodes', { outlets: { 'my-shortcode-tab': ['receipt', pendingOrder.orderId] } }] } }]">{{
                                pendingOrder.orderId }}</a></span>
                    </p>
                    <p>
                        <span>You will receive an email notification with a copy of your receipt shortly. </span>
                        <span>You can also download your receipt using the link, below.</span>
                    </p>
                    <a class="link lg" style="cursor: pointer;" (click)="downloadReceiptPdf()">Download Receipt</a>
                    <p class="mt-2">Since you have chosen to automatically renew the short code(s) on this order into
                        monthly billing upon
                        payment of the initial pre-paid term, a billed monthly order has been created and is the latest
                        order for
                        the short code(s). The short code(s) will be billed monthly following the completion of the
                        pre-paid term.</p>
                </div>
            </div>
            <div *ngIf="conditionalTextObject.renew">
                <div *ngIf="!conditionalTextObject.bulkRenew">
                    <div class="col-12 ps-0"
                        *ngIf="conditionalTextObject.payNow && !conditionalTextObject.renewIntoMB && !conditionalTextObject.renew1Plus12TooLate">
                        <p>
                            <span>You have renewed your short code order, and it is now in Approved status.</span>
                            <span>The order ID of the renewed order is: <a class="link" style="cursor: pointer;"
                                    [routerLink]="['/dashboard',{ outlets: { 'navbar-tab': ['my-shortcodes', { outlets: { 'my-shortcode-tab': ['receipt', pendingOrder.orderId] } }] } }]">{{
                                    pendingOrder.orderId }}</a> </span>
                        </p>
                        <p>
                            <span>You will receive an email notification with a copy of your receipt shortly.</span>
                            <span>You can also download your receipt using the link, below.</span>
                        </p>
                        <a class="link lg" style="cursor: pointer;" (click)="downloadReceiptPdf()">Download Receipt</a>
                    </div>
                    <div class="col-12 ps-0"
                        *ngIf="!conditionalTextObject.payNow && !conditionalTextObject.renewIntoMB">
                        <p>
                            <span>You have started the process to renew your short code order. </span>
                            <span>An order has been created for the renewal, and payment is due by {{
                                pendingOrder.paymentDueDate | date }}.</span>
                            <span>Your Order ID is: <a class="link" style="cursor: pointer;"
                                    [routerLink]="['/dashboard',{ outlets: { 'navbar-tab': ['my-shortcodes', { outlets: { 'my-shortcode-tab': ['invoice', pendingOrder.orderId] } }] } }]">{{
                                    pendingOrder.orderId }}</a>
                            </span>
                        </p>
                        <p>
                            <span>You will receive an email notification with a copy of your invoice shortly.</span>
                            <span>You can also download your invoice using the link, below.</span>
                        </p>

                        <a class="link lg" style="cursor: pointer;" (click)="downloadInvoicePdf()">Download Invoice</a>
                    </div>
                    <div class="col-12 ps-0" *ngIf="conditionalTextObject.renewDirecttoMB">
                        <p>
                            <span>You have renewed your short code order, and your short code is now in Approved
                                status.</span>
                            <span>The order ID of the renewed order is: <a class="link" style="cursor: pointer;"
                                    [routerLink]="['/dashboard',{ outlets: { 'navbar-tab': ['my-shortcodes', { outlets: { 'my-shortcode-tab': ['statement', pendingOrder.orderId] } }] } }]">{{
                                    pendingOrder.orderId }}</a> </span>
                        </p>
                        <p>
                            <span>Since you have renewed this short code into Monthly Billing, there will be no separate
                                invoice for it,</span>
                            <span>rather this short code will be included in your monthly invoice starting {{
                                pendingOrder.invoiceDate | date:'MMMM dd, yyyy' }}.</span>
                        </p>
                    </div>
                    <div class="col-12 ps-0"
                        *ngIf="conditionalTextObject.payNow  && conditionalTextObject.renew1Plus12 && !conditionalTextObject.renew1Plus12TooLate">
                        <p>
                            <span>You have renewed your short code order into a 1-Month pre-paid lease, which is in
                                Approved status.</span>
                            <span>The order ID of this 1-month lease is: <a class="link" style="cursor: pointer;"
                                    [routerLink]="['/dashboard',{ outlets: { 'navbar-tab': ['my-shortcodes', { outlets: { 'my-shortcode-tab': ['receipt', pendingOrder.orderId] } }] } }]">{{
                                    pendingOrder.orderId }}</a> </span>
                        </p>
                        <p>
                            <span>You will receive an email notification with a copy of your receipt for the 1-Month
                                lease shortly.</span>
                            <span>You can also download this receipt using the link below.</span>
                        </p>
                        <p>This short code will be included in your monthly invoice starting {{
                            pendingOrder.monBillStartDateStr }}.</p>
                        <a class="link lg" style="cursor: pointer;" (click)="downloadReceiptPdf()">Download Receipt</a>
                    </div>
                    <div class="col-12 ps-0" *ngIf="conditionalTextObject.renew1Plus12TooLate">
                        <p>
                            <span>You have renewed your short code.</span>
                            <span>The order ID of the renewed order is: <a class="link" style="cursor: pointer;"
                                    [routerLink]="['/dashboard',{ outlets: { 'navbar-tab': ['my-shortcodes', { outlets: { 'my-shortcode-tab': ['receipt', pendingOrder.orderId] } }] } }]">{{
                                    pendingOrder.orderId }}</a> </span>
                        </p>
                        <p>
                            <span>Unfortunately, the payment was received after the deadline for the monthly billing
                                invoice generation,
                                so this short code can no longer be automatically rolled over into monthly billing.
                                If you want to add this short code to monthly billing, you will need to manually renew
                                it again and select the Monthly Billing term option, if available.</span>
                        </p>
                        <p>
                            <span>You will receive an email notification with a copy of your receipt shortly.</span>
                            <span>You can also download your receipt using the link, below.</span>
                        </p>
                        <a class="link lg" style="cursor: pointer;" (click)="downloadReceiptPdf()">Download Receipt</a>
                    </div>
                    <div class="col-12 ps-0"
                        *ngIf="!conditionalTextObject.payNow  && conditionalTextObject.renew1Plus12">
                        <p>
                            <span>You have started the process to renew your short code into monthly billing.</span>
                            <span>An order for a 1-Month pre-paid lease has been created for the renewal, and payment is
                                due.</span>
                            <span>The order ID of this 1-month lease is: <a class="link" style="cursor: pointer;"
                                    [routerLink]="['/dashboard',{ outlets: { 'navbar-tab': ['my-shortcodes', { outlets: { 'my-shortcode-tab': ['invoice', pendingOrder.orderId] } }] } }]">{{
                                    pendingOrder.orderId }}</a> </span>
                        </p>
                        <p>
                            <span>You will receive an email notification with a copy of your invoice for the 1-Month
                                lease shortly.</span>
                            <span>You can also download this invoice using the link below.</span>
                            <span>To ensure successful addition of this short code into monthly billing,
                                payment of the 1-Month lease is due by {{ pendingOrder.renewalDeadLineStr}}.</span>
                        </p>
                        <a class="link lg" style="cursor: pointer;" (click)="downloadInvoicePdf()">Download Invoice</a>
                    </div>
                </div>
                <div class="col-12 ps-0" *ngIf="!conditionalTextObject.payNow && conditionalTextObject.bulkRenew">
                    <p>
                        <span>You have started the process to renew the short codes listed below.</span>
                    </p>
                    <p>
                        <span>You will receive an email confirmation with a summary of your renewal requests, including links to the orders, shortly.
                            Once you receive that message, you can remit payment for these orders.</span>
                    </p>
                </div>
                <div class="col-12 ps-0" *ngIf="conditionalTextObject.payNow && conditionalTextObject.bulkRenew">
                    <p>
                        <span>You have renewed the short codes listed below, and the order is in Approved status.</span>
                        <span>The order ID of the renewal order is: <a class="link" style="cursor: pointer;"
                                [routerLink]="['/dashboard',{ outlets: { 'navbar-tab': ['my-shortcodes', { outlets: { 'my-shortcode-tab': ['receipt', pendingOrder.orderId] } }] } }]">{{
                                pendingOrder.orderId }}</a> </span>
                    </p>
                    <p>
                        <span>You will receive an email notification with a summary of your bulk renewal and a copy of
                            your receipt shortly.</span>
                        <span>You can also download your receipt using the link below.</span>
                    </p>
                    <a class="link lg" style="cursor: pointer;" (click)="downloadReceiptPdf()">Download Receipt</a>
                </div>
            </div>
            <p-table styleClass="p-datatable-striped" [columns]="tableColumn" [value]="pendingOrder.leases" [autoLayout]="true">
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th *ngFor="let col of columns" class="noBorder" [ngClass]="col.field">
                            {{col.header}}
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData let-columns="columns">
                    <tr>
                        <td *ngFor="let col of columns" class="noBorder" [ngSwitch]="col.field" [ngClass]="col.field">
                            <div *ngSwitchDefault>{{ rowData[col.field] }}</div>
                            <div *ngSwitchCase="'scId'">
                                <a class="link"
                                    [routerLink]="['/dashboard', { outlets: { 'navbar-tab': ['my-shortcodes', { outlets: { 'my-shortcode-tab': ['shortcode-list', {scId: rowData[col.field]}] } }] } }]">{{
                                    rowData[col.field] }}</a> <span
                                    *ngIf="rowData.ANString">({{rowData?.ANString}})</span>
                                <!-- ['shortcode-list'], { state: { scId: rowData[col.field]  } } -->
                            </div>
                            <div *ngSwitchCase="'price'">
                                <span
                                    *ngIf="!conditionalTextObject.renew1Plus12 ||
                                             (conditionalTextObject.renew1Plus12 && conditionalTextObject.payNow) ||
                                             (conditionalTextObject.renew1Plus12 && !conditionalTextObject.payNow && rowData.leaseType !== 'BilledMonthly') ||
                                             (conditionalTextObject.renew1Plus12 && !conditionalTextObject.payNow && rowData.leaseType === 'BilledMonthly' && getDiscountList(rowData).length === 0 )">
                                    {{ rowData[col.field] | currency }}
                                </span>
                                <span *ngIf="conditionalTextObject.renew1Plus12 &&
                                             !conditionalTextObject.payNow && 
                                             rowData.leaseType === 'BilledMonthly' &&
                                             (rowData.discountAmount !== 0 ||  getDiscountList(rowData).length >0 )">
                                    To Be Determined
                                </span>
                            </div>
                            <div *ngSwitchCase="'shortCodeType'">
                                {{ rowData.selectType }}
                            </div>
                            <div *ngSwitchCase="'term'">
                                {{rowData.term | termLength: rowData.leaseType }}
                            </div>
                            <div *ngSwitchCase="'autoRenew'">
                                {{ rowData.autorenew | autoRenew }}
                            </div>
                            <div class='text-nowrap' *ngSwitchCase="'discount'">
                                <span *ngIf="(!conditionalTextObject.renew1Plus12 ||
                                    (conditionalTextObject.renew1Plus12 && conditionalTextObject.payNow) || 
                                    (conditionalTextObject.renew1Plus12 && !conditionalTextObject.payNow && rowData.leaseType !== 'BilledMonthly') )&&
                                    (rowData.discountAmount !== 0 ||  getDiscountList(rowData).length >0 )">
                                    {{ getDiscountList(rowData) }} <span *ngIf="rowData.discountAmount">({{
                                        rowData.discountAmount | currency }}) </span>
                                </span>
                                <span *ngIf="conditionalTextObject.renew1Plus12 && 
                                            !conditionalTextObject.payNow && 
                                            rowData.leaseType === 'BilledMonthly' &&
                                            (rowData.discountAmount !== 0 ||  getDiscountList(rowData).length >0 )">
                                    To Be Determined
                                </span>
                            </div>
                            <div *ngSwitchCase="'listPrice'">
                                {{ rowData.listPrice | currency }}
                            </div>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
            <div *ngIf="pendingOrder && (!conditionalTextObject.renewIntoMB || conditionalTextObject.renew1Plus12TooLate)"
                class="mt-3">
                <h5><b>Total:&nbsp;&nbsp;{{ pendingOrder.totalPrice | currency }}</b></h5>
            </div>

            <div *ngIf="pendingOrder && conditionalTextObject.renewDirecttoMB" class="mt-3">
                <h5><b>Total:&nbsp;&nbsp;{{ pendingOrder.totalPrice | currency }}
                        (To be paid in monthly installments of {{ installments|scrMoney}} as part of the monthly
                        invoice.)</b></h5>
            </div>

            <div *ngIf="pendingOrder && conditionalTextObject.payNow && conditionalTextObject.renew1Plus12 && !conditionalTextObject.renew1Plus12TooLate"
                class="mt-3">
                <table>
                    <tr>
                        <td>
                            <h5><b>Total: </b></h5>
                        </td>
                        <td class="money">
                            <h5><b>{{ ( pendingOrder.totalPrice ) | currency }} </b></h5>
                        </td>
                        <td>
                            <h5><b> ( {{ pendingOrder.leases[0].price | currency}} to be paid in monthly installments
                                    of {{ (pendingOrder.leases[0].price || 0)/12 | currency}}.)</b></h5>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <h5><b>Paid: </b></h5>
                        </td>
                        <td class="money">
                            <h5><b>{{pendingOrder.leases[1].price | currency}} </b></h5>
                        </td>
                        <td>
                            <h5><b> ( For the 1-Month lease that will automatically roll over into Monthly Billing.)</b>
                            </h5>
                        </td>
                    </tr>
                </table>

            </div>
            <div *ngIf="pendingOrder && !conditionalTextObject.payNow && conditionalTextObject.renew1Plus12 && !conditionalTextObject.renew1Plus12TooLate && getDiscountList(pendingOrder.leases[0]).length === 0"
                class="mt-3">
                <table>
                    <tr>
                        <td>
                            <h5><b>Total: </b></h5>
                        </td>
                        <td class="money">
                            <h5><b>{{(pendingOrder.totalPrice ) | currency }} </b></h5>
                        </td>
                        <td>
                            <h5><b> ( {{ pendingOrder.leases[0].price | currency}} to be paid in monthly installments
                                    of {{ (pendingOrder.leases[0].price || 0)/12 | currency}}. )</b></h5>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <h5><b>Due Now: </b></h5>
                        </td>
                        <td class="money">
                            <h5><b>{{pendingOrder.leases[1].price | currency}} </b></h5>
                        </td>
                        <td>
                            <h5><b> ( For the 1-Month lease that will automatically roll over into Monthly Billing.
                                    )</b></h5>
                        </td>
                    </tr>
                </table>
            </div>
            <div *ngIf="pendingOrder && !conditionalTextObject.payNow && conditionalTextObject.renew1Plus12 && !conditionalTextObject.renew1Plus12TooLate && getDiscountList(pendingOrder.leases[0]).length>0 "
                class="mt-3">
                <table>
                    <tr>
                        <h5><b>Total: To Be Determined</b></h5>
                    </tr>
                    <tr>
                        <h5><b>Due Now: {{pendingOrder.leases[1].price | currency}} ( For the 1-Month lease that will
                                automatically roll over into Monthly Billing. )</b></h5>
                    </tr>
                </table>
            </div>

        </div>
        <div class="col-9" *ngIf="conditionalTextObject.monthlyInvoiceManualPay">
            <div class="col-8 ps-0">
                <p>You have remitted payment for your monthly invoice, <a class="link" style="cursor: pointer;"
                        [routerLink]="['/dashboard',{ outlets: { 'navbar-tab': ['my-shortcodes', { outlets: { 'my-shortcode-tab': ['receipt', pendingOrder.orderId] } }] } }]">{{
                        pendingOrder.orderId }}</a>, and will receive an email notification with a copy of your receipt
                    shortly. </p>
                <p>The short codes included in this receipt will be automatically included in next month's monthly
                    invoice
                    without any additional action on your part.</p>

                <a class="link lg" style="cursor: pointer;" (click)="downloadReceiptPdf()">Download Receipt</a>
            </div>
            <div *ngIf="pendingOrder" class="mt-3">
                <h5><b>Total Codes in Monthly Invoice:&nbsp;&nbsp;{{ pendingOrder.lines.length }}</b></h5>
            </div>
            <div *ngIf="pendingOrder" class="mt-3">
                <h5><b>Total:&nbsp;&nbsp;{{ pendingOrder.totalPrice | currency }}</b></h5>
            </div>
        </div>
    </div>
    <div class="row ">
        <div *ngIf="leaseApplicationData && !conditionalTextObject.monthlyInvoiceManualPay" class="col-4 mt-4">
            <h3>CSC Registrant Information</h3>
            <div class="me-4 mb-2">{{ leaseApplicationData.firstName }} {{ leaseApplicationData.lastName }}</div>
            <div class="me-4 mb-2">
                <div class="truncate" [pTooltip]="leaseApplicationData.address1 ? leaseApplicationData.address1 : ''"
                    tooltipPosition="top" appShowToolTipIfTruncated>{{ leaseApplicationData.address1 }}</div>
                <div class="truncate" [pTooltip]="leaseApplicationData.address2 ? leaseApplicationData.address2 : ''"
                    appShowToolTipIfTruncated *ngIf="leaseApplicationData.address2">{{leaseApplicationData.address2 }}
                </div>
                <div class="truncate"
                    [pTooltip]="leaseApplicationData.state ? leaseApplicationData.city + ', ' + leaseApplicationData.state + ' ' + leaseApplicationData.zip  : leaseApplicationData.city ? leaseApplicationData.city : ''"
                    tooltipPosition="top" appShowToolTipIfTruncated>{{ leaseApplicationData.city }}<span
                        *ngIf="leaseApplicationData.state">,</span> {{ leaseApplicationData.state }} {{
                    leaseApplicationData.zip }}</div>
                {{ leaseApplicationData.country | scrConfig:'country'}}
            </div>
            <div class="me-4 mb-2 truncate" [pTooltip]="leaseApplicationData.email  ? leaseApplicationData.email  : ''"
                tooltipPosition="top" appShowToolTipIfTruncated>{{ leaseApplicationData.email }}</div>
            <div class="me-4 mb-2">{{ leaseApplicationData.phone | phoneNumber }} <span
                    *ngIf="leaseApplicationData.phoneExtension">&nbsp; Ext. {{ leaseApplicationData.phoneExtension
                    }}</span></div>
        </div>
        <div class="col-6 mt-4">
            <h3>Billing & Payment Information</h3>
            <div class="me-4 mb-2">{{ pendingOrder.billingFirstName }} {{ pendingOrder.billingLastName }}</div>
            <div class="me-4 mb-2">
                <div class="truncate" [pTooltip]="pendingOrder.billingAddress1 ? pendingOrder.billingAddress1 : ''"
                    tooltipPosition="top" appShowToolTipIfTruncated>{{ pendingOrder.billingAddress1 }}</div>
                <div class="truncate" [pTooltip]="pendingOrder.billingAddress2 ? pendingOrder.billingAddress2 : ''"
                    tooltipPosition="top" appShowToolTipIfTruncated *ngIf="pendingOrder.billingAddress2">{{
                    pendingOrder.billingAddress2}}</div>
                <div class="truncate"
                    [pTooltip]="pendingOrder.billingState ? pendingOrder.billingCity + ', ' + pendingOrder.billingState + ' ' + pendingOrder.billingZip  : pendingOrder.billingCity ? pendingOrder.billingCity : ''"
                    tooltipPosition="top" appShowToolTipIfTruncated>{{ pendingOrder.billingCity }}<span
                        *ngIf="pendingOrder.billingState">,</span> {{ pendingOrder.billingState }} {{
                    pendingOrder.billingZip }}</div>
                {{ pendingOrder.billingCountry | scrConfig:'country'}}
            </div>
            <div class="me-4 mb-2 truncate" [pTooltip]="pendingOrder.billingEmail ? pendingOrder.billingEmail : ''"
                tooltipPosition="top" appShowToolTipIfTruncated>{{ pendingOrder.billingEmail }}</div>
            <div class="me-4 mb-2">{{ pendingOrder.billingPhone | phoneNumber }}<span
                    *ngIf="pendingOrder.billingPhoneExtension">&nbsp;Ext. {{ pendingOrder.billingPhoneExtension
                    }}</span></div>
        </div>
    </div>
    <div class="row mt-2" *ngIf="availableCredit !== null && availableCredit !== undefined">
        <div class="col-12">
            <h5>Available Account Credit: {{availableCredit | currency}}</h5>
        </div>
    </div>
</div>